import { IsEmptyString } from "../../Components/GeneralFunctions.jsx"

export function EmbeddedZohoGetLastInsertedCallId() {
    return localStorage.getItem("embeddedzoho_lastinsertedcallid")
}

export function EmbeddedZohoSetLastInsertedCallId(value) {
    localStorage.setItem("embeddedzoho_lastinsertedcallid", value)
}

export function EmbeddedZohoGetLastInsertedZohoCallId() {
    return localStorage.getItem("embeddedzoho_lastinsertedzohocallid")
}

export function EmbeddedZohoSetLastInsertedZohoCallId(value) {
    localStorage.setItem("embeddedzoho_lastinsertedzohocallid", value)
}

export function EmbeddedZohoGetLastAutoOpenMatch() {
    return localStorage.getItem("embeddedzoho_lastautoopenmatchcallid")
}

export function EmbeddedZohoSetLastAutoOpenMatch(value) {
    localStorage.setItem("embeddedzoho_lastautoopenmatchcallid", value)
}

export function EmbeddedZohoGetLastAutoCreateMatch() {
    return localStorage.getItem("embeddedzoho_lastautocreatematchcallid")
}

export function EmbeddedZohoSetLastAutoCreateMatch(value) {
    localStorage.setItem("embeddedzoho_lastautocreatematchcallid", value)
}

//==> SETTINGS

export function EmbeddedZohoGetSettingAutoCreateCall() {
    return localStorage.getItem("embeddedzoho_setting_autocreatecall")
}

export function EmbeddedZohoSetSettingAutoCreateCall(value) {
    localStorage.setItem("embeddedzoho_setting_autocreatecall", value)
}

export function EmbeddedZohoGetSettingAutoOpenMatch() {
    return localStorage.getItem("embeddedzoho_setting_autoopenmatch")
}

export function EmbeddedZohoSetSettingAutoOpenMatch(value) {
    localStorage.setItem("embeddedzoho_setting_autoopenmatch", value)
}

export function EmbeddedZohoGetSettingAutoCreateMatch() {
    return localStorage.getItem("embeddedzoho_setting_autocreatematch")
}

export function EmbeddedZohoSetSettingAutoCreateMatch(value) {
    localStorage.setItem("embeddedzoho_setting_autocreatematch", value)
}

export function EmbeddedZohoGetSettingDefaultInboundCallSubject() {
    let Result = localStorage.getItem("embeddedzoho_setting_defaultinboundcallsubject")
    if (IsEmptyString(Result))
    {
        Result = "Call from <number>"
    }
    return Result    
}

export function EmbeddedZohoSetSettingDefaultInboundCallSubject(value) {
    localStorage.setItem("embeddedzoho_setting_defaultinboundcallsubject", value)
}

export function EmbeddedZohoGetSettingDefaultOutboundCallSubject() {
    let Result = localStorage.getItem("embeddedzoho_setting_defaultoutboundcallsubject")
    if (IsEmptyString(Result))
    {
        Result = "Call to <number>"
    }
    return Result    
}

export function EmbeddedZohoSetSettingDefaultOutboundCallSubject(value) {
    localStorage.setItem("embeddedzoho_setting_defaultoutboundcallsubject", value)
}